module.exports = __webpack_public_path__ + "img/model_41_zh.98590d02.jpg";